module.exports = __webpack_public_path__ + "img/interface_prize.51434252.png";